import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import useFiltersVariables from "components/Filters/useFiltersVariables";
import { getSearchQuery } from "components/SearchInput/helpers";

import { FILTER_KEY_CATEGORIES, FILTER_KEY_CONFIGURED, FILTER_VARIABLES } from "../constants";
import { filterIntegrations } from "../helpers";
import { useIntegrations } from "./useIntegrations";

export const useFilteredIntegrations = () => {
  const [searchParams] = useSearchParams();
  const { filterVariables } = useFiltersVariables(FILTER_VARIABLES);
  const { integrations, loading, error } = useIntegrations();

  const filteredIntegrations = useMemo(() => {
    const searchQuery = getSearchQuery(searchParams);

    const categoriesValues =
      filterVariables.predicates.find((predicate) => predicate.field === FILTER_KEY_CATEGORIES)
        ?.constraint.enumEquals ?? [];

    const configuredValues =
      filterVariables.predicates.find((predicate) => predicate.field === FILTER_KEY_CONFIGURED)
        ?.constraint.booleanEquals ?? [];

    return filterIntegrations(integrations, searchQuery, categoriesValues, configuredValues);
  }, [filterVariables.predicates, searchParams, integrations]);

  return {
    filteredIntegrations,
    loading,
    error,
  };
};
